var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inward"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('packingb2b.tab1'),
      "active": ""
    },
    on: {
      "click": _vm.resetForm
    }
  }, [(_vm.showeye1 == true) ? _c('div', [_c('b-card', [(_vm.css1) ? _c('div', {
    staticStyle: {
      "margin-top": "-4px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.b2bBoxQc')))])])]) : _vm._e(), _vm._v(" "), (_vm.css2) ? _c('div', {
    staticStyle: {
      "margin-top": "-6px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.b2bBoxQc')))])]), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "top": "0px",
      "left": "118px"
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.orderOrigin')) + " :\n                  "), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.orderType))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "171px",
      "top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.clientName')) + " : "), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.clientName))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.css3) ? _c('div', {
    staticStyle: {
      "margin-top": "-8px"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(255 112 8)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.boxQc')))])]), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "top": "0px",
      "left": "118px"
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.orderOrigin')) + " :\n                  "), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.orderType))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "172px",
      "top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.clientName')) + ":"), (_vm.showBoxDetails) ? _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.clientName))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.boxId')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('boxList.boxIdPlaceHolder'),
      "name": "boxid",
      "id": "boxid",
      "min": "1"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.getBoxDetails($event)
      }
    },
    model: {
      value: (_vm.finalObject.boxId),
      callback: function($$v) {
        _vm.finalObject.boxId = $$v
      },
      expression: "finalObject.boxId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxid')),
      expression: "errors.has('boxid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('boxid')))])], 1)], 1)]), _vm._v(" "), (_vm.finalObject.boxId) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "id": "submitbtn",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.getBoxDetails()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(_vm._s(_vm.$t('boxList.boxDetailsb2b')))])])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.showBoxDetails && _vm.finalObject.boxId) ? _c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center",
    slot: "header"
  }, [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "width": "315px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('boxList.boxProductDetails')) + "\n                ")]), _vm._v(" "), (_vm.specialInstructionButton == true) ? _c('button', {
    staticClass: "btn btn-success mb-1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getSpecialInstructionModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('config.specialInstructions')))]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "scroll-container"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('printProductDetails.clientProductId')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('printProductDetails.productName')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.productEancode')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.quantity')))])])])])]), _vm._v(" "), _vm._l((_vm.boxdatas), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(data.clientproductid) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s(data.productname))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(data.eancode) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_c('p', [_vm._v(_vm._s(data.qty))])])])])
  }), _vm._v(" "), (_vm.boxdatas.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('merchant.noRecordFound')))])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails && _vm.finalObject.boxId) ? _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "width": "315px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('boxList.boxId')) + " : "), _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.orderId))])]), _vm._v(" "), (_vm.finalObject.orderShiByDate) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "5px",
      "top": "-3px",
      "width": "315px"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.shipByDate')) + " : "), _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(_vm.dateFormatDetail(this.finalObject.orderShiByDate)))])]) : _vm._e()]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.orderQuantity')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.showPackingCompleteButton) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.totalOrderQty))])]) : _vm._e(), _vm._v(" "), (!_vm.showPackingCompleteButton) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "11px"
    }
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.totalOrderQty))])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('tr', [(_vm.showPackingCompleteButton) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxSku')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxQuantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxQtyCancelled')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.showPackingCompleteButton) ? _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.totalSkus))])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.totalQty))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(this.finalObject.cancelQty))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [(_vm.finalObject.merchantName) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.merchant')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.shipmentId) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipmentId')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.salesChannel) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.awbNo) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.awbNo')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.shippingCourierCompany) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.ShippingProvider')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.courierName) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.selfShipped')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center cardreporttabletr"
  }, [(_vm.finalObject.merchantName) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.merchantName))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.shipmentId) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.shipmentId))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.salesChannel) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.salesChannel))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.awbNo) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.awbNo))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.shippingCourierCompany) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.courierName))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.shippingCourierCompany) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.shippingCourierCompany))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.courierName && !_vm.finalObject.shippingCourierCompany) ? _c('td', [_vm._v(_vm._s(_vm.finalObject.courierName))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.orderSelfshipped) ? _c('td', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), (!_vm.finalObject.orderSelfshipped) ? _c('td', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("No")]) : _vm._e()])])])]), _vm._v(" "), (_vm.showPackingCompleteButton) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('td', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "13px",
      "color": "#413535"
    },
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.productQCDetails')))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.totalQCAcceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.totalQCRejectedQty')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(this.finalObject.qtyQcAccept))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_c('p', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(this.finalObject.qtyQcReject))])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.cancelQty > 0) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('td', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "13px",
      "color": "#413535"
    },
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.cancelledQuantityDetails')))])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('warehouseRacks.rackId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('inwardList.printData.printBarcode.heading')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.pickedQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.cancelledQuantity')))])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.finalObject.cancelProductDetails), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pickqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.cancelqty))])])
  }))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showBoxDetails && _vm.finalObject.boxId) ? _c('b-card', [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    slot: "header"
  }, [(!_vm.allowPackingComplete) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "color": "green"
    }
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('boxList.scanProduct')))])]) : _vm._e(), _vm._v(" "), (_vm.allowPackingComplete) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "2px",
      "top": "-3px",
      "color": "green"
    }
  }, [(_vm.finalObject.boxStatus && _vm.finalObject.boxStatus == 'in_picking') ? _c('b', [_vm._v(" " + _vm._s(_vm.$t('boxList.inPicking')))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.boxStatus && _vm.finalObject.boxStatus == 'in_packing') ? _c('b', [_vm._v(" " + _vm._s(_vm.$t('boxList.inPacking')))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.boxStatus && _vm.finalObject.boxStatus == 'in_shipping') ? _c('b', [_vm._v(" " + _vm._s(_vm.$t('boxList.packingCompleted')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "11px",
      "top": "-3px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('boxList.boxStatus')) + " : "), _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.boxStatus))])]), _vm._v(" "), _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "60px",
      "top": "-3px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('orders.orderStatus')) + ": "), _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.orderStatus))])]), _vm._v(" "), (_vm.finalObject.shipmentStatus) ? _c('span', {
    staticClass: "clientnamecss",
    staticStyle: {
      "left": "99px",
      "top": "-3px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('orders.shipementStatus')) + ": "), _c('span', {
    staticStyle: {
      "color": "rgb(174 45 14)"
    }
  }, [_vm._v(_vm._s(this.finalObject.shipmentStatus))])]) : _vm._e()]), _vm._v(" "), (_vm.showPackingCompleteButton && _vm.showQCAndPackingSection) ? _c('fieldset', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingFeild
    }
  }), _vm._v(" "), (!_vm.allowPackingComplete) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalObject.productId),
      expression: "finalObject.productId"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('boxList.productPlaceholder'),
      "name": "productid",
      "id": "productid"
    },
    domProps: {
      "value": (_vm.finalObject.productId)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.scanProduct($event)
      },
      "keydown": function($event) {
        _vm.detectKeyPressEventupdate($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalObject.productId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.scanProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.scan')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showProductQcDetails && !_vm.isProductReject) ? _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.finalObject.showQtyInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalObject.productQty),
      expression: "finalObject.productQty"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.quantity'),
      "name": "productQty",
      "id": "productQty"
    },
    domProps: {
      "value": (_vm.finalObject.productQty)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalObject.productQty = $event.target.value
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showProductQcDetails && !_vm.isProductReject) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.productQC('accept')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('receivedEmail.accept')))]), _vm._v("  \n                      ")]) : _vm._e(), _vm._v(" "), (_vm.showProductQcDetails && !_vm.isProductReject) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": true,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.productQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('receivedEmail.reject')))])]) : _vm._e(), _vm._v(" "), (_vm.isProductReject) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "options": _vm.options,
      "multiple": "",
      "item-color": "success",
      "placeholder": _vm.$t('boxList.reasonPlaceholder'),
      "hide-selected": true,
      "name": "Reject Reason"
    },
    on: {
      "input": _vm.rejectedReasonsSelected
    },
    model: {
      value: (_vm.rejectReasons),
      callback: function($$v) {
        _vm.rejectReasons = $$v
      },
      expression: "rejectReasons"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isProductReject) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.updateQcDetails('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('receivedEmail.reject')))])]) : _vm._e()])]), _vm._v(" "), (_vm.showProductQcDetails) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [(_vm.finalObject.scanproductData.productimage) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productImage')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productname) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productName')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.brand) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.brand')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.size) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('printProductDetails.size')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.color) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('printProductDetails.color')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.mrp) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.mrp')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productcategory) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productCategory')))])]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productdescription) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productDescription')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.finalObject.scanproductData.productimage) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.finalObject.scanproductData.productimage,
      "width": "100px",
      "height": "120px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productname) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.finalObject.scanproductData.productname))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.brand) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.finalObject.scanproductData.brand))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.size) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.finalObject.scanproductData.size))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.color) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.finalObject.scanproductData.color))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.mrp) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.finalObject.scanproductData.mrp))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productcategory) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.finalObject.scanproductData.productcategory))]) : _vm._e(), _vm._v(" "), (_vm.finalObject.scanproductData.productdescription) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.finalObject.scanproductData.productdescription))]) : _vm._e()])])])]), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.allowPackingComplete && !_vm.showSplitBoxData) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.Qccomplete.b2b_qc_done != 2) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.boxWeight')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Qccomplete.boxweight')
    },
    attrs: {
      "type": "text",
      "name": "boxweight",
      "id": "boxweight"
    },
    model: {
      value: (_vm.Qccomplete.boxweight),
      callback: function($$v) {
        _vm.Qccomplete.boxweight = $$v
      },
      expression: "Qccomplete.boxweight"
    }
  }), _vm._v(" "), _vm._v("\n                       \n                      "), _c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "float": "right",
      "margin-left": "10px",
      "color": "white"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.getWeight
    }
  }, [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.getWeightButton')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Qccomplete.boxweight')),
      expression: "errors.has('Qccomplete.boxweight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('boxweight')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allowPackingComplete && !_vm.showSplitBoxData) ? _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "float": "right",
      "margin-top": "30px"
    }
  }, [(_vm.Qccomplete.b2b_qc_done != 2) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.saveWeight()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')) + " ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-top": "15px"
    }
  }, [(_vm.Qccomplete.b2b_qc_done == 2) ? _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-top": "5px",
      "margin-right": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.PrintPackdata(_vm.finalObject)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('boxList.printSlip')))])]) : _vm._e(), _vm._v(" "), (_vm.Qccomplete.b2b_qc_done != 2) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.changeBoxStatus
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.qcBoxDoneButton')))])]) : _vm._e(), _vm._v(" "), (_vm.Qccomplete.remainingqty == 0 && _vm.Qccomplete.b2b_qc_done == 2) ? _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [function($event) {
        _vm.adddetails()
      }, function($event) {
        _vm.tabIndex++
      }]
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.addShipdetails')))])]) : _vm._e(), _vm._v(" "), (_vm.Qccomplete.remainingqty > 0 && _vm.Qccomplete.b2b_qc_done == 2) ? _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-top": "5px",
      "margin-left": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.qcAnotherBox')))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showSplitBoxData) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('td', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "13px",
      "color": "#413535"
    },
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.sourceBoxDetails')))])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.boxId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.productEancode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.productQuantity')))])])])]), _vm._v(" "), _c('tbody', [(_vm.sourceBoxData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('merchant.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sourceBoxData), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productqty))])])
  })], 2)])]), _vm._v(" "), (_vm.destinationBoxData.length > 0) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "overflow": "auto"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('td', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "13px",
      "color": "#413535"
    },
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.destinationBoxDetails')))])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.boxId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.productEancode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.productQuantity')))])])])]), _vm._v(" "), _c('tbody', [(_vm.destinationBoxData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('merchant.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.destinationBoxData), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productqty))])])
  })], 2)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showSplitBoxData) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('destinationBoxId')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('printProductDetails.destinationBoxPlaceholder'),
      "name": "destinationBoxId",
      "id": "destinationBoxId",
      "min": "1"
    },
    model: {
      value: (_vm.destinationBoxId),
      callback: function($$v) {
        _vm.destinationBoxId = $$v
      },
      expression: "destinationBoxId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destinationBoxId')),
      expression: "errors.has('destinationBoxId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destinationBoxId')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#673AB7"
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.validateBox
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n                      " + _vm._s(_vm.$t('boxList.validateBox')))])]), _vm._v(" "), (_vm.showSplitButton) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('destinationBoxId')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('printProductDetails.productIdPlaceHolder'),
      "name": "destinationProductID",
      "id": "destinationProductID"
    },
    model: {
      value: (_vm.destinationProductID),
      callback: function($$v) {
        _vm.destinationProductID = $$v
      },
      expression: "destinationProductID"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destinationProductID')),
      expression: "errors.has('destinationProductID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destinationProductID')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.destinationProductID && _vm.showSplitButton) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.splitBoxProducts
    }
  }, [_c('i', {
    staticClass: "fa fa-chain-broken"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.splitBox')))])]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.allowPackingComplete && _vm.Qccomplete.b2b_qc_done == 2 && !_vm.showPackingCompleteButton && !_vm.showPackingCompleteButton) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "5px",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading || _vm.isLoadingFeild,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.PrintPackdata(_vm.finalObject)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('boxList.printSlip')))])]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showeye1 == false) ? _c('div', [_c('div', [_c('printpackdata', {
    attrs: {
      "filterData": _vm.filterData,
      "pono1": _vm.selectedRow
    },
    on: {
      "goBackToParent": _vm.callParent1
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('packingb2b.tab2'),
      "active": ""
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('section', {
    staticClass: "grcreport"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.orderIDPlaceholder')
    },
    model: {
      value: (_vm.Qccomplete.orderid),
      callback: function($$v) {
        _vm.Qccomplete.orderid = $$v
      },
      expression: "Qccomplete.orderid"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.orderCreatedFromDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.Qccomplete.ordercreatedfromdate),
      callback: function($$v) {
        _vm.Qccomplete.ordercreatedfromdate = $$v
      },
      expression: "Qccomplete.ordercreatedfromdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.orderCreatedToDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.Qccomplete.ordercreatedtodate),
      callback: function($$v) {
        _vm.Qccomplete.ordercreatedtodate = $$v
      },
      expression: "Qccomplete.ordercreatedtodate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.shipbyFromDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.Qccomplete.Shipbyfromdate),
      callback: function($$v) {
        _vm.Qccomplete.Shipbyfromdate = $$v
      },
      expression: "Qccomplete.Shipbyfromdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.shipbyToDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.Qccomplete.Shipbytodate),
      callback: function($$v) {
        _vm.Qccomplete.Shipbytodate = $$v
      },
      expression: "Qccomplete.Shipbytodate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getb2bQcdonelisting()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormlisting
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('packingb2b.b2bPacking.table.title')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader",
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-1.5 cardlistheader",
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.b2bOrderId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.orderCreatedDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.shippedByDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.totalBox')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.orderQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.qcDoneQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.qcSKU')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.table.columns.action')))])])])]), _vm._v(" "), _c('tbody', [(_vm.Qccomplete.warehouse != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noSearchBtnMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.listb2bQcdone.length == 0 && _vm.warehouse != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listb2bQcdone), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.order_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddatetime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.shipbydatetime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxes))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.acceptedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.acceptedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalitem))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticStyle: {
        "color": "#44b8bd"
      },
      on: {
        "click": function($event) {
          _vm.AddshipmentDetails(data, _vm.res_client, _vm.res_warehouse)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.addShipDetails')))])])])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-backdrop": true
    },
    model: {
      value: (_vm.AddshipmentDetail),
      callback: function($$v) {
        _vm.AddshipmentDetail = $$v
      },
      expression: "AddshipmentDetail"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "col-14"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "margin": "0px !important"
    }
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.addShipDetails')))]), _vm._v(" "), (_vm.showButtonManualPacking) ? _c('span', {
    staticClass: "testing",
    staticStyle: {
      "left": "238px",
      "top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.manualPacking')))]) : _vm._e(), _vm._v(" "), (_vm.showButtonManualPacking) ? _c('label', {
    staticClass: "switch",
    staticStyle: {
      "left": "80px",
      "top": "5px"
    }
  }, [_c('input', {
    attrs: {
      "size": "sm",
      "id": "manualPackingEnable",
      "type": "checkbox"
    },
    on: {
      "change": _vm.manualPackingEnable
    }
  }), _c('span', {
    staticClass: "slider round"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAddshipdetails
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0.25rem !important"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h6', {
    staticClass: "header",
    staticStyle: {
      "font-size": "15px",
      "font-family": "Times New Roman, Times, serif"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.b2bOrderId')))]), _vm._v(" " + _vm._s(_vm.addshipdetails.orderId))])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.totalBoxes')) + " "), _c('b', [_vm._v(_vm._s(_vm.addshipdetails.totalboxes) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.totalWeight')) + " "), (_vm.editweight == false) ? _c('b', [_vm._v(_vm._s(_vm.addshipdetails.orderweight))]) : _vm._e()]), _vm._v(" "), (_vm.editweight == false && !_vm.hideediticon) ? _c('i', {
    staticClass: "fa fa-pencil fa-lg mt-2 ml-3",
    attrs: {
      "title": "Edit "
    },
    on: {
      "click": function($event) {
        _vm.editweight = true;
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editweight == true) ? _c('div', {
    staticClass: "col-5"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('packingb2b.b2bPacking.modal.totalWeightPlaceholder')
    },
    model: {
      value: (_vm.addshipdetails.orderweight),
      callback: function($$v) {
        _vm.addshipdetails.orderweight = $$v
      },
      expression: "addshipdetails.orderweight"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getBoxDetailsb2b(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.exportBoxData')) + " ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-container",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "scroll-container"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.boxID')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.totalSKUQuantity')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.weight')))])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.dimensions')))])])])])]), _vm._v(" "), _vm._l((_vm.listb2bBoxlist), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(data.boxid) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s(data.totalboxquantity))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(data.weight) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_c('span', [_c('p', [_vm._v(_vm._s(data.length) + "x" + _vm._s(data.width) + "x" + _vm._s(data.height))])])])])
  }), _vm._v(" "), (_vm.listb2bBoxlist.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font": "22px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.invoiceDetails')))])]), _vm._v(" "), _c('b-card', {
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.invoiceNumber'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('packingb2b.b2bPacking.modal.invoiceNumberPlaceHolder'),
      "id": "invoiceno"
    },
    model: {
      value: (_vm.addinvoicedetails.invoiceno),
      callback: function($$v) {
        _vm.addinvoicedetails.invoiceno = $$v
      },
      expression: "addinvoicedetails.invoiceno"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "float": "right",
      "margin-top": "-58px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.invoiceValue'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('packingb2b.b2bPacking.modal.invoiceValuePlaceholder'),
      "id": "value"
    },
    model: {
      value: (_vm.addinvoicedetails.value),
      callback: function($$v) {
        _vm.addinvoicedetails.value = $$v
      },
      expression: "addinvoicedetails.value"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.ewayBill')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('packingb2b.b2bPacking.modal.ewayBillPlaceholder'),
      "id": "ewaybill"
    },
    model: {
      value: (_vm.addinvoicedetails.ewaybill),
      callback: function($$v) {
        _vm.addinvoicedetails.ewaybill = $$v
      },
      expression: "addinvoicedetails.ewaybill"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "-25px"
    }
  }, [(_vm.finalObject.showInvoiceButton && _vm.showInvoiceAndLabels) ? _c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "background-color": "#44b8bd",
      "color": "white"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printInvoice
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" " + _vm._s(_vm.$t('packingb2b.b2bPacking.modal.printInvoice')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.finalObject.showInvoiceButton && _vm.showInvoiceAndLabels) ? _c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "background-color": "rgb(117 175 66)",
      "color": "white"
    },
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "success",
      "disabled": _vm.isLoading || _vm.isLoadingFeild
    },
    on: {
      "click": function($event) {
        _vm.printLabel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v("\n                            " + _vm._s(_vm.$t('packingb2b.b2bPacking.modal.printLabel')))]) : _vm._e()])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font": "22px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.shipDetails')))])]), _vm._v(" "), _c('b-card', {
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.courierCompany'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalObject.courierName),
      expression: "finalObject.courierName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('couriername')
    },
    attrs: {
      "name": "couriername",
      "id": "couriername"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.finalObject.courierName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.courierSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.courierCompanyPlaceholder')))]), _vm._v(" "), _vm._l((_vm.finalObject.salesChannelList), function(courier_obj) {
    return _c('option', {
      domProps: {
        "value": courier_obj.courierid
      }
    }, [_vm._v(_vm._s(courier_obj.couriername))])
  })], 2)]), _vm._v(" "), (_vm.showerrorCouriercompany == true) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('couriername')),
      expression: "errors.has('couriername')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.courierCompanyError')))]) : _vm._e(), _vm._v(" "), (_vm.addotherscourier == true) ? _c('div', {
    staticClass: "col-md-15",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('packingb2b.b2bPacking.modal.enterCourierCompany'),
      "id": "couriername"
    },
    model: {
      value: (_vm.finalObject.OthercourierName),
      callback: function($$v) {
        _vm.finalObject.OthercourierName = $$v
      },
      expression: "finalObject.OthercourierName"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-left": "4px"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square fa-lg mt-4",
    attrs: {
      "title": _vm.$t('packingb2b.b2bPacking.modal.addCourierCompany')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveOtherCourier()
      }
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.awbNo'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbno')
    },
    attrs: {
      "type": "text",
      "disabled": _vm.finalObject.xbEcomFlag || _vm.finalObject.isRubicon || _vm.finalObject.isWmall || _vm.finalObject.isMultiseller || _vm.finalObject.isUnicommerce || _vm.finalObject.isNimbus,
      "placeholder": _vm.$t('packingb2b.b2bPacking.modal.awbPlaceholder'),
      "name": "awbno",
      "id": "awbno"
    },
    model: {
      value: (_vm.finalObject.awbNo),
      callback: function($$v) {
        _vm.finalObject.awbNo = $$v
      },
      expression: "finalObject.awbNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbno')),
      expression: "errors.has('awbno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.awbNoError')))])], 1), _vm._v(" "), _c('br')])])], 1)]), _vm._v(" "), (_vm.showclosebutton == false) ? _c('div', {
    staticClass: "row float-right"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "size": "sm",
      "disabled": !_vm.isComplete
    },
    on: {
      "click": _vm.markorderpacked
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('packingb2b.b2bPacking.modal.markOrderBtn')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeAddshipdetails
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('packingb2b.b2bPacking.modal.close')) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.showclosebutton == true) ? _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeAddshipdetails
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('packingb2b.b2bPacking.modal.close')) + " ")])])]) : _vm._e()])])], 1)], 1)])])], 1)])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.closeSpecialInstructionModal = false
      }
    },
    model: {
      value: (_vm.specialInstructionModel),
      callback: function($$v) {
        _vm.specialInstructionModel = $$v
      },
      expression: "specialInstructionModel"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('config.specialInstructions')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeSpecialInstructionModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.specialInstructionCount == 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('config.specialInstructionNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.specialInstructionList), function(instruction) {
    return (_vm.specialInstructionCount > 0) ? _c('ul', {
      key: instruction.instructionid
    }, [_c('li', [_vm._v("\n                " + _vm._s(instruction.instructionname) + "\n              ")])]) : _vm._e()
  })], 2)], 1)])], 1)])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a36d88b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a36d88b0","hasScoped":true}!./src/views/components/packingb2b/packingb2b.component.html
// module id = 1955
// module chunks = 0